import * as React from 'react'
import { IProject } from '../..'

const proj: IProject = {
    id: 'onigasm',
    name: 'Onigasm',
    type: 'lib',
    tags: ['typescript', 'c++', 'webassembly', 'text-processing'],
    containsVideos: true,
    description: (
        <>
        <p>Oniguruma regex engine ported to the web w/ WebAssembly.</p>
        <p>Onigasm unlocked new possibilities and is now being used in:</p>
        <ul>
            <li> <a href='https://github.com/Microsoft/vscode-textmate/blob/6b4f4d7bfde2c1baaf8b25906657fd6d5075a6a3/src/onigLibs.ts#L14'>Microsoft's VSCode (monaco)</a></li>
            <li> <a href='https://about.gitlab.com/2018/06/15/introducing-gitlab-s-integrated-development-environment/'>GitLab's WebIDE</a></li>
            <li><a href='https://github.com/theia-ide/theia'>TypeFox's Theia IDE</a></li>
        </ul>
        </>
    ),
    links: new Map()
        .set('GitHub Repository', 'https://github.com/NeekSandhu/onigasm')
}

export default proj



// WEBPACK FOOTER //
// ./src/components/Projects/_projects/onigasm/index.tsx